import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import VueGtag from 'vue-gtag'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './custom.scss'
import '@/plugins/custom-component'
import '@/plugins/bootstrap-vue'
import Validation from './plugins/validation'
import Axios from './plugins/axios'
import BaseAxios from './plugins/base-axios'
import Filters from './plugins/filters'

// sentryの設定
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
    // vue用のintegrationで、vue warnなどを捕捉してsentryに送信する
    // ref: https://docs.sentry.io/platforms/javascript/guides/vue/
      new VueIntegration({
        Vue,
        tracing: true,
        // トップレベルコンポーネントだけでなく全ての子コンポーネントも追跡する
        tracingOptions: {
          trackComponents: true,
        },
        // 開発者コンソールにvueのエラーを表示するために必要
        logErrors: true
      }),
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
}
Vue.config.productionTip = false
Vue.use(Validation)
Vue.use(Filters)

Vue.use(Axios, {
  initialToken: store.state.auth.accessToken,
  apiUrl: store.getters['auth/apiUrl'],
  refreshTokenCb: async () => {
    // トークンのリフレッシュを試みる
    return await store.dispatch('auth/refreshAccessToken')
  },
  getTokenCb: () => {
    // 最新のアクセストークンを取得
    return store.state.auth.accessToken
  },
  authErrorCb: async () => {
    console.warn('認証エラー: ログアウトします')
    store.commit('notify/set', {message: 'セッションが切れました。もう一度ログインしてください。'})
    await store.dispatch('auth/logout')
    router.push('/auth/login')
  }
})

Vue.use(BaseAxios)

// Google Analyticsの設定
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_ID,
    params: {
      send_page_view: false
    }
  }
}, router)

// アプリが更新された日時をstoreに保存
window.onload = () => {
  store.commit('setLoadedAt', new Date())
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
